/*
 * @Author: CYX
 * @Date: 2020-07-10 14:56:31
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-10 15:32:40
 */ 
export const AddressBookCn = {
    address: "地址薄",
    namePehop: "请输入收货人名称/联系方式",
    shousuo: "搜索",
    ADDaddress: "新增收货地址",
    shouhuoren: "收货人",
    szaddress: "所在地区",
    szaddress1: "所在地区：",
    jdaddress: "街道地址",
    lianxidianhua: "联系电话",
    sheweimr: "设为默认",
    shrxxdz: "请输入公司名称",
    qsrshrsjhm: "请输入收货人手机号码",
    qxzgsmc: "请选择公司名称",
    qsrzqdsjhm: "请输入正确的手机号码",
    qsrsjhm: "请输入手机号码",
    qsrzqdyx: "请输入正确的邮箱"
}


// WEBPACK FOOTER //
// ./src/lang/member/AddressBook/indexCn.js